"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const auth_types_1 = require("pages/auth/auth.types");
const error_response_1 = require("utils/error-response");
const get_from_localstorage_1 = require("utils/get-from-localstorage");
const changePassword = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/user/auth/changePassword';
    try {
        const { data } = yield axios_1.default.post(url, arg, {
            headers: {
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
            }
        });
        return {
            isError: false,
            errorMessage: '',
            errorCode: 0,
            data: {
                isAuthenticated: data.data.isAuthenticated,
                token: data.data.token,
                userData: data.data.userData,
                defaultPassword: data.data.defaultPassword
            }
        };
    }
    catch (e) {
        const response = (0, error_response_1.errorResponse)(e);
        return Object.assign(Object.assign({}, response), { data: {
                isAuthenticated: false,
                token: '',
                userData: auth_types_1.initialUserProfile,
                defaultPassword: false
            } });
    }
});
exports.default = changePassword;
